export default __webpack_public_path__ + "static/media/rectangle.7b2dee00.svg";